export default __webpack_public_path__ + "static/media/Koruri-Semibold.c756195b.ttf";